<template>
    <div class="takeOutEleDetail">
        <Header backType="blank" :backStyle="style" :svgColor="'#fff'" :back="!fromXBH"></Header>
        <!-- <Header backType="blank" :backStyle="style" :svgColor="'#fff'"></Header> -->
        <div
            class="merchantImg"
            :style="{backgroundImage:'url(' + (result.shopImg || 'https://pic.downk.cc/item/5e81a6f2504f4bcb0418357b.jpg').split('?')[0] + ')',backgroundSize: 'cover'}"
        ></div>
        <div class="merchantContent">
            <div class="merchantName">{{result.shopName}}</div>
            <div class="merchantMsg">
                <p @click="ihtml.telCall(result.shopMobile)">{{result.shopMobile}}</p>
                <p>{{result.shopAddress}}</p>
            </div>
            <div class="merchantGroup">
                <div class="merchantGroupHead">需求明细</div>
                <ul class="merchantGroupList">
                    <li>
                        <span class="merchantGroupLabel">订单状态</span>
                        <span class="merchantGroupTxt">{{result.statusTxt}}</span>
                    </li>
                    <li v-if="result.dtStart">
                        <span class="merchantGroupLabel">用餐时间</span>
                        <span class="merchantGroupTxt">{{ result.dtStart | dateTime }}～{{ result.dtEnd | dateTime }}</span>
                    </li>
                    <li>
                        <span class="merchantGroupLabel">用餐类型</span>
                        <span class="merchantGroupTxt">{{result.itemName}}</span>
                    </li>
                    <li v-if="result.mealType">
                        <span class="merchantGroupLabel">用餐形式</span>
                        <span class="merchantGroupTxt">{{result.mealType}}</span>
                    </li>
                    <li v-if="result.actualQty">
                        <span class="merchantGroupLabel">实际人数</span>
                        <span class="merchantGroupTxt">{{result.actualQty}}</span>
                    </li>
                    <li v-if="['pfizer'].includes(event.tenant_code)">
                        <span class="merchantGroupLabel">外部用餐人数</span>
                        <span class="merchantGroupTxt">{{result.outPeople}}</span>
                    </li>
                    <li v-if="['pfizer'].includes(event.tenant_code)">
                        <span class="merchantGroupLabel">内部用餐人数</span>
                        <span class="merchantGroupTxt">{{result.innerPeople}}</span>
                    </li>
                    <li v-if="result.settleAmount">
                        <span class="merchantGroupLabel">实际金额</span>
                        <span class="merchantGroupTxt">¥ {{parseFloat(result.settleAmount).toFixed(2)}}</span>
                    </li>
                    <li>
                        <span class="merchantGroupLabel">订餐人姓名</span>
                        <span class="merchantGroupTxt">{{result.bookingName}}</span>
                    </li>
                    <li>
                        <span class="merchantGroupLabel">订餐人电话</span>
                        <span class="merchantFont merchantGroupTxt">{{result.bookingMobile}}</span>
                    </li>
                    <li v-if="orderDetail.extOrderId && (((orderDetail.itsItemData || { payProfile:'' }).payProfile || {PayModes: []}).PayModes[0] == 8)">
                        <span class="merchantGroupLabel">饿了么订单号</span>
                        <span class="merchantGroupTxt">{{orderDetail.extOrderId}}</span>
                    </li>
                    <li v-if="orderDetail.itsItemData.isBusiness === 1">
                        <span class="merchantGroupLabel">友情提示</span>
                        <span class="merchantGroupTxt">餐厅确认收款，请告知其登录饿了么后台进行查看。</span>
                    </li>
                    <li>
                        <span class="merchantGroupLabel">备注</span>
                        <span class="merchantGroupTxt">{{result.descr}}</span>
                    </li>
                </ul>
            </div>
            <div class="merchantBtnRow">
                <div class="merchantGroupHead">水单</div>
                <viewer v-if="waterFilesList.length" :images="waterFilesList" class="imgContainer">
                    <template v-for="(list) in waterFilesList">
                        <div :key="list.url">
                            <img v-if="list.fileType != '.pdf'" :src="list.url" alt/>
                            <div  @click="openPdf(list.url)" v-else>
                                <i-icon style="width:.8rem;height:.8rem" class="icon-pdf" color="var(--themeColor)" name="icon-pdf" />
                            </div>
                        </div>
                    </template>
                </viewer>
                <div class="nodata" v-else>
                    暂无数据！
                </div>
            </div>
            <div class="merchantBtnRow">
                <div class="merchantGroupHead">发票</div>
                <viewer v-if="invoiceFilesList.length" :images="invoiceFilesList" class="imgContainer">
                    <template v-for="(list) in invoiceFilesList">
                        <div :key="list.url">
                            <div  @click="openPdf(list.url)" v-if="list.fileType == '.pdf'">
                                <i-icon style="width:.8rem;height:.8rem" class="icon-pdf" color="var(--themeColor)" name="icon-pdf" />
                            </div>
                            <div  @click="openOfd(list.url)" v-else-if="list.fileType == '.ofd'">
                                <img src="../../assets/img/ofd.png" style="width:.8rem;height:.8rem"/>                             </div>
                            <img v-else :src="list.url" alt/>
                        </div>
                    </template>
                </viewer>
                <div class="nodata" v-else>
                    暂无数据！
                </div>
            </div>
            <div class="merchantBtnRow" v-if="result.invoiceReason">
                <div class="merchantGroupHead">原因</div>
                <p class="invoiceReason">
                    {{result.invoiceReason}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { miceService } from "@/service/miceService.js";
import { UploadPlug } from "smart-filer";
import { SmartStorage } from 'smart-core-util'
import { Toast } from 'mint-ui';
const uploadInstance = new UploadPlug({
  host: process.env.VUE_APP_GATEWAY
});
export default {
    name: "MealDetail",
    computed: {
        ...mapGetters(["event", "orderDetail"])
    },
    data() {
        return {
            fromXBH: false,
            result: {},
            waterFilesList: [],
            invoiceFilesList: [],
            style: {
                width: "0.3rem",
                height: "0.3rem",
                borderRadius: "50%",
                background: "rgba(0, 0, 0, 0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        };
    },
    mounted() {
        this.fromXBH = SmartStorage.get('isH5')
        this.getMealItemDetail();
        this.getWaterFiles();
        this.getInvoiceFiles();
    },
    methods: {
        openPdf(pdfUrl){
            this.iJsBridge.openPdfImg(pdfUrl)
            // window.open(pdfUrl)
        },
        openOfd(){
            Toast('暂不支持预览Ofd格式文件');
        },
        getMealItemDetail() {
            const params = {
                itemId: this.orderDetail.itemId
            };
            miceService.getMealItemDetail(params).then(res => {
                if (res && res.success) {
                    this.result = res.content;
                }
            });
        },
        getWaterFiles() {
            uploadInstance.queryFile({
                filterData: {
                    filterData: {
                        processId: this.orderDetail.proposalId,
                        relatedId: this.orderDetail.itemId,
                        relatedType: ["settle", "settle_reback", "SupplierSettle"],
                        catalog: "水单"
                    }
                },
                callback: data => {
                    this.waterFilesList = data.content
                }
            })
        },
        getInvoiceFiles() {
            uploadInstance.queryFile({
                filterData: {
                    filterData: {
                        processId: this.orderDetail.proposalId,
                        itemId: this.orderDetail.itemId,
                        relatedType: ["Invoice", "Invoice_reback"],
                        catalog: "发票"
                    }
                },
                callback: data => {
                    this.invoiceFilesList = data.content

                }
            })
        }
    },
    filters: {
        dateTime: value => {
            if (value) {
                return value.substring(0, 10) + " " + value.substring(11, 16);
            }
        }
    }
};
</script>

<style lang="scss">
.merchantBtnRow .icon-pdf{
    width: 0.8rem;
    height: 0.8rem;
    margin: 0.2rem 0.2rem 0 0;
    border-radius: 0.2rem;
}
.invoiceReason{
    word-wrap:break-word;
    text-align: left;
    margin-top: .2rem
}
@import "MealOrderDetail";
</style>